<template lang="pug">
table.table-hover.reports-table.expenses-report-table.table
  ExpensesReportTableHeader

  // eslint-disable vue/require-v-for-key
  template(v-for="section in tableData.sections")
    tbody.grouping-header
      tr
        th
          template(v-if="walker.main_type === 'date'")
            | {{ formatDateLabel(section.main) }}
          template(v-else-if="walker.main_type === 'user'")
            ReportTableAvatar(
              :user-id="section.main_id"
              :url="section.rows[0].record.avatar_url"
            )
            | {{ section.main }}
          template(v-else-if="walker.main_type === 'project'")
            template(v-if="section.main !== null")
              ReportTableAvatarInitial(
                :text="section.main"
                class-modifier="avatar avatar-speck"
              )
              | {{ section.main }}
            template(v-else)
              span.text-lighter
                | No project
          template(v-else)
            | {{ section.main }}
        th(
          v-for="col in baseColCount - 1"
          :key="col"
        )

    tbody.ttotal(
      :class="{ 'is-expanded': showToggledSectionById(section.main_id) }"
      @click="toggleSection(section)"
    )
      tr.cursor-pointer
        td.totals-row
          span.expand-rows-toggle(:class="{ 'is-expanded': showToggledSectionById(section.main_id) }")
            i.hi.hi-caret
            span
              | Total

        td(v-if="walker.sub_show")
        td(v-if="tableShowDescription")
        td(v-if="tableShowAmount") {{ $filters.currency(section.total.amount, organization.currency) }}
        td(v-if="tableShowCategory")
        td(v-if="tableShowNotes")

    tbody.tbody(v-show="showToggledSectionById(section.main_id)")
      tr(
        v-for="row in section.rows"
        :key="row.record.id"
        :class="{ 'has-border': row.sub_show_data }"
      )
        template(v-if="walker.sub_show")
          td(v-if="row.sub_show_data")
            template(v-if="walker.sub_type === 'date'")
              | {{ formatDateLabel(row.record.sub) }}
            template(v-else-if="walker.sub_type === 'user'")
              ReportTableAvatar(
                :user-id="row.record.sub_id"
                :url="row.record.avatar_url"
              )
              | {{ row.record.sub }}
            template(v-else-if="walker.sub_type === 'project'")
              template(v-if="row.record.sub !== null")
                ReportTableAvatarInitial(
                  :text="row.record.sub"
                  class-modifier="avatar avatar-speck"
                )
                | {{ row.record.sub }}
              template(v-else)
                span.text-lighter
                  | No project
            template(v-else)
              | {{ row.record.sub }}
          td(v-else)
            template(v-if="walker.sub_type === 'project' && row.record.sub === null")
              span.text-lighter
                | No project

        template(v-if="walker.third_show")
          td(v-if="row.third_show_data")
            template(v-if="walker.third_type === 'date'")
              | {{ formatDateLabel(row.record.third) }}
            template(v-else-if="walker.third_type === 'user'")
              ReportTableAvatar(
                :user-id="row.record.third_id"
                :url="row.record.avatar_url"
              )
              | {{ row.record.third }}
            template(v-else-if="walker.third_type === 'project'")
              template(v-if="row.record.third !== null")
                ReportTableAvatarInitial(
                  :text="row.record.third"
                  class-modifier="avatar avatar-speck"
                )
                | {{ row.record.third }}
              template(v-else)
                span.text-lighter
                  | No project
            template(v-else)
              | {{ row.record.third }}
          td(v-else)
            template(v-if="walker.third_type === 'project' && row.record.third === null")
              span.text-lighter
                | No project
        template(v-else)
          td

        td(v-if="tableShowDescription")
          | {{ row.record.description }}
        td(v-if="tableShowAmount")
          | {{ $filters.currency(row.record.amount, organization.currency) }}
          i.fa.fa-dollar.a-tooltip.ml-5(
            v-if="row.record.billable"
            v-tooltip="{ placement: 'right' }"
            title="Billable expense"
          )
        td(v-if="tableShowCategory")
          | {{ row.record.category }}
        td.long-text-cell(
          v-if="tableShowNotes"
          v-popover:left="{ html: false }"
          :data-content="row.record.notes"
        )
          | {{ row.record.notes }}
  // eslint-enable vue/require-v-for-key
</template>
<script>
import { mapGetters, mapState } from 'vuex';

import ExpensesReportTableHeader from './ExpensesReportTableHeader.vue';

export default {
  name: 'ExpensesReportTable',
  components: { ExpensesReportTableHeader },
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'walker',
      'tableIsTeam',
      'showToggledSectionById',
      'tableShowNotes',
      'tableShowDescription',
      'tableShowCategory',
      'tableShowAmount',
    ]),
    ...mapState({
      organization: 'organization',
    }),
    baseColCount() {
      return (
        !!this.walker.sub_show +
        !!this.walker.third_show +
        !!this.tableShowNotes +
        !!this.tableShowDescription +
        !!this.tableShowCategory +
        !!this.tableShowAmount
      );
    },
  },
  methods: {
    toggleSection(section) {
      this.$store.dispatch('toggleSection', {
        section_id: section.main_id,
        section_count: this.tableData.sections.length,
      });
    },
    formatDateLabel(value) {
      if (value === 'summed_date') {
        return (
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date)) +
          ' - ' +
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date_end))
        );
      }

      return TimeUtils.format_date(TimeUtils.parse_internal_date(value));
    },
  },
};
</script>
